import React, { useEffect, useState } from "react";
// import Image from "../../../components/atom/image";
// import renderHTML from 'react-render-html';
import { Link, withRouter } from 'react-router-dom';
import Cookie from '../../../lib/cookie';
import Api from "../../../services/loginApi";
import { useHistory } from "react-router-dom";
import { getDecryptedItem, setEncryptedItem } from "../../../helper/methods";

let api = new Api();
let cookie = new Cookie();

const Sidebar = (props) => {
  const history = useHistory();
  const [open, setOpen] = useState('');
  console.log(props, 'privateRoutre', props.location.pathname)
  let getpathName = props.location.pathname;
  const isPathActive = (getpathName) => {
    console.log(getpathName, 'isPathActivePATH')
    return props.location.pathname.startsWith(getpathName);
  }
  console.log(isPathActive(getpathName), 'isPathActive');
  const panNumber = getDecryptedItem('uniqueKey');
  const productDtls = props.productDtls;
  const ARNCode = props.ARNCode;
  const uniqueKey = props.uniqueKey;
  const redirectDitUrl = props.redirectDitUrl;
  const onlyProductNames = props.onlyProductNames;
  
  console.log("checking at line 23: ",  productDtls, ARNCode, redirectDitUrl, onlyProductNames, uniqueKey)
  const menuHandler = (data, boolVal, link, label) => {

    if(redirectDitUrl !== '' || redirectDitUrl !== null) {
      localStorage.setItem('redirectDitUrl', redirectDitUrl);
    }

    if (label === "Contact Us") {
      let parsedPanData = panNumber;
      console.log("checking at line 24: ", parsedPanData);
      const filterValue = 'MF';

      let productDtlsParsed = JSON.parse(productDtls);
      let ProductData = productDtlsParsed?.productDtls;
      let arnCodeValue = ProductData?.find(product => product?.productType === "MF")?.arnCode;

      localStorage.setItem('redirectDitUrl', filterValue)
      if (arnCodeValue) {
        localStorage.setItem('ARNCode', arnCodeValue);
      }

      let payload = {
        "apiName": "CommonDistributorToken",
        "body": {
          "panNo": parsedPanData?.panNo,
          "arnCode": arnCodeValue,
          "productType": filterValue
        }
      }
      console.log(payload, 'CommonDistributorToken')
      api.common(payload).then(res => {
        if (res.data.success) {
          console.log("checking at line 43: ", res)
          let { fName } = res.data.data.userInfo;
          setEncryptedItem("uniqueKey", { panNo: parsedPanData?.panNo, nameAsOnPan: fName, productType: filterValue });
          localStorage.setItem("authDetailsForMF", JSON.stringify(res.data.data.userInfo));

        } else {
          let msg = res.data.message;
          console.log("checking at line 52: ", msg);
          alert(msg);
        }
        console.log('DITresToken', res)
      }).catch((e) => {
        console.log("checking at line 57: ", e)
      })
    }

    if (label === "Feedback") {
      window.open(link, "_blank")
    }

    if (open === data) {
      setOpen('')
    } else {
      setOpen(data)
    }

    console.log(boolVal);
    if (boolVal === 0) {
      document.body.classList.add('sidebar-icon-only');
      document.querySelector('.sidebar-offcanvas').classList.remove('active');
    }

  }

  const handleNavigation = (data, boolVal, link, label) => {

    if(redirectDitUrl !== '' || redirectDitUrl !== null) {
      localStorage.setItem('redirectDitUrl', redirectDitUrl);
    }
    
    if (label === "Feedback" || label === "Onboard Investor") {
      window.open(link, "_blank")
    } else if (label === "Dashboard" || label === "Contact Us") {
      history.push(link)
    }
    if (open === data) {
      setOpen('')
    } else {
      setOpen(data)
    }

    console.log(boolVal);
    if (boolVal === 0) {
      document.body.classList.add('sidebar-icon-only');
      document.querySelector('.sidebar-offcanvas').classList.remove('active');
    }  
  };

  // added by Nikesh
  const menuHandlertwist = () => {

    document.body.classList.add('sidebar-icon-only');
    document.querySelector('.sidebar-offcanvas').classList.remove('active');
  }


  useEffect(() => {
    const body = document.querySelector('body');

    document.querySelectorAll('.sidebar .nav-item').forEach((el) => {
      el.addEventListener('mouseover', function () {
        if (body.classList.contains('sidebar-icon-only')) {
          el.classList.add('hover-open');
        }
      });
      el.addEventListener('mouseout', function () {
        if (body.classList.contains('sidebar-icon-only')) {
          el.classList.remove('hover-open');
        }
      });
    });
  }, [])

  let getOption = props.option;


  return (
    <React.Fragment>
      <nav class="sidebar sidebar-offcanvas" id="sidebar">
        <ul class="nav">

          {
            cookie.getCookie('distype') !== "AIF" ? 
              <li class="nav-item">
                <a
                  href={cookie.getCookie('distype') === "PMS" ?
                    `${process.env.REACT_APP_DIT_PMS_ABSOLUTE_URL}/Dashboard` :
                    `${process.env.REACT_APP_DIT_AIF_ABSOLUTE_URL}/report`}
                  class="nav-link"
                // target="_blank"
                >
                  <span className="icon-bg">
                    <i className={"myportfolio_navicon"}></i>
                  </span>
                  <span className="menu-title">{"Dashboard"}</span>
                </a>
              </li>
              :
              ''
          }

          {getOption.map((curr, index) => {
            let { menu, subMenu } = curr;
            let active = false;
            let innerActive = false;
            active = isPathActive(curr.menu.linkTo);

            let innermenu = "";
            let SubmenuLink = "";
            let innermenuCall = 0;
            if (subMenu) {
              innermenuCall = 1;
              innermenu = subMenu.map((Cursub, index1) => {
                console.log(Cursub.menu.linkTo, 'Cursub', getpathName)
                innerActive = getpathName === Cursub.menu.linkTo;
                if (getpathName === Cursub.menu.linkTo) {
                  SubmenuLink = Cursub.menu.linkTo;
                }

                return (
                  <li class="nav-item">
                    {
                      curr.menu.type === "a" ?
                        <a class={`nav-link ${getpathName === Cursub.menu.linkTo ? "active" : ""}`} href={process.env.REACT_APP_DIT_PMS_ABSOLUTE_URL + Cursub.menu.linkTo} onClick={() => menuHandlertwist()}>
                          {Cursub.menu.label}
                        </a>
                        :
                        <Link class={`nav-link ${getpathName === Cursub.menu.linkTo ? "active" : ""}`} to={Cursub.menu.linkTo} onClick={() => menuHandlertwist()}>
                          {Cursub.menu.label}
                        </Link>
                    }
                  </li>
                )

              })
            }
            console.log(innerActive, 'SideBarinnerActive,', SubmenuLink, '==', getpathName)
            return (
              // <li className={`nav-item ${getpathName === curr.menu.linkTo || SubmenuLink === getpathName ? "active " : ""} ${open === 'menu' + index ? "open" : ""}`}>
              //   <Link to={innermenu == "" ? curr.menu.linkTo : "#"} className={`nav-link ${innermenu !== "" ? "dropsubmenu" : null}`} onClick={() => menuHandler(`menu${index}`, innermenuCall)}>
              //     <span className="icon-bg">
              //       {/* <i className="mdi mdi-crosshairs-gps menu-icon"></i> */}
              //       <i className={curr.menu.class}></i>
              //     </span>
              //     {curr.menu.label === "Dashboard" ?
              //       <span className="menu-title"
              //         onClick={() => { cookie.getCookie('distype') === "PMS" ? window.location.href = `${process.env.REACT_APP_DIT_PMS_ABSOLUTE_URL}/Dashboard` : window.location.href = `${process.env.REACT_APP_DIT_AIF_ABSOLUTE_URL}/report` }}>{curr.menu.label}</span> :
              //       <span className="menu-title">{curr.menu.label}</span>
              //     }
              //     {/* <span className="menu-title">{curr.menu.label}</span> */}
              //     {innermenu !== "" ? <i class="menu-arrow"></i> : null}
              //   </Link>
              //   {innermenu !== "" ?
              //     <div className={`collapse ${open === 'menu' + index ? 'show' : null}`} >
              //       <ul className="nav flex-column sub-menu">{innermenu}</ul>
              //     </div>
              //     : null}

              // </li>
              <li className={`nav-item ${getpathName === curr.menu.linkTo || SubmenuLink === getpathName ? "active " : ""} ${open === 'menu' + index ? "open" : ""}`}>
                {/* <Link to={curr.menu.url ? "#" : innermenu === "" ? curr.menu.linkTo : "#"} className={`nav-link ${innermenu !== "" ? "dropsubmenu" : null}`} onClick={() => menuHandler(`menu${index}`, innermenuCall, curr.menu.linkTo, curr.menu.label)}>
                  <span className="icon-bg">
                    <i className={curr.menu.class}></i>
                  </span>
                  <span className="menu-title">{curr.menu.label}</span>
                  {innermenu !== "" ? <i class="menu-arrow"></i> : null}
                </Link> */}
                <div onClick={() => handleNavigation(`menu${index}`, innermenuCall, curr.menu.linkTo, curr.menu.label)} className={`nav-link ${innermenu !== "" ? "dropsubmenu" : null}`} >
                  <span className="icon-bg">
                    <i className={curr.menu.class}></i>
                  </span>
                  <span className="menu-title">{curr.menu.label}</span>
                  {innermenu !== "" ? <i className="menu-arrow"></i> : null}
                </div>
                {innermenu !== "" ?
                  <div className={`collapse ${open === 'menu' + index ? 'show' : null}`} >
                    <ul className="nav flex-column sub-menu">{innermenu}</ul>
                  </div>
                  : null}

              </li>
            )
          })
          }

        </ul>
      </nav>
    </React.Fragment>
  );

};

export default withRouter(Sidebar);